import { MessageBusService } from './message-bus-service';
import { Injectable } from '@angular/core';

@Injectable()
export class GlobalMessageBusService extends MessageBusService {

}
